module.exports = __webpack_public_path__ + "img/2023-17.b14f1cf0.jpg";